"use client";
import Image from "next/image";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function DevelopmentProcessAnimation() {
  return (
    <Image
    width={1128}
    height={600}
    src={"/images/qualitia-development.webp"}
    alt={"Qualitia Boson"}
    className='w-full max-w-[1128px] h-auto mx-auto'
    />
  );
}
